<template>
  <div class="section-search-result">
    <!-- Searching State -->
    <TemplateSliderSkeleton v-if="isSearching && !isLoadingMore" />

    <!-- Search with No Result State -->
    <TemplateSearchNoData
      v-if="noResult && !isSearching"
      :isInEditor="isInEditor"
      :keyword="searchText"
      @request="clearSearch"
    />

    <!-- Search with Result State -->
    <template v-if="!isSearching && !noResult">
      <div v-if="hasFilteredPresentations" class="text-left mb-4">
        <span
          v-html="
            $i18nPresenter.t('filteredPresentationsTotalResult', {
              length: filteredPresentations.length,
              text: searchText
            })
          "
        ></span>
      </div>
      <div
        v-if="hasFilteredPresentations"
        class="templates"
      >
        <div class="templates-container grid-card-row editor-template-container">
          <TemplateCard
            v-for="presentation in filteredPresentations"
            :key="presentation.id"
            v-aha-emit-action="{ template_id: presentation.id }"
            name="template-card"
            :presentation="presentation"
          />
        </div>

        <div v-if="isLoadmore" class="w-full my-4 text-center">
          <aha-button
            v-aha-emit-action
            name="template_library_load_more_btn"
            :submitting="isLoadingMore"
            :disabled="isLoadingMore"
            @click="loadMore"
          >
            {{ $i18nPresenter.t('Load more...') }}
          </aha-button>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import TemplateCard from './TemplateCard.vue'
import TemplateSearchNoData from '@/components-v2/common/template-library/TemplateSearchNodataMergeSearch.vue'
import TemplateSliderSkeleton from './TemplateSliderSkeleton.vue'

export default {
  components: {
    TemplateCard,
    TemplateSearchNoData,
    TemplateSliderSkeleton,
  },
  props: {
    filteredPresentations: {
      type: Array,
      default: () => [],
    },
    noResult: {
      type: Boolean,
      default: false,
    },
    isSearching: {
      type: Boolean,
      default: false,
    },
    searchText: {
      type: String,
      default: '',
    },
    isLoadmore: {
      type: Boolean,
      default: false,
    },
    isLoadingMore: {
      type: Boolean,
      default: false,
    },
    isInEditor: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    hasFilteredPresentations() {
      return this.filteredPresentations && this.filteredPresentations.length > 0
    },
  },
  methods: {
    loadMore() {
      this.$emit('loadMore')
    },
    clearSearch() {
      this.$emit('clearSearch')
    },
  },
}
</script>

<style scoped lang="scss">
.grid-card-row {
  @apply grid gap-x-4 gap-y-5 md:gap-8 xl:gap-4 2xl:gap-6 3xl:gap-8;
  @apply grid-cols-1 sm:grid-cols-2 md:grid-cols-3 2xl:grid-cols-4 3xl:grid-cols-5;

  @media (min-width: 2000px) {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }
}
</style>
